import { ASSET_REDUCER_KEY } from "./reducer";

export const getAssetData = (state) => {
    return state[ASSET_REDUCER_KEY].assetData;
};
